import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryFinancialAccountBalanceSummary } from '../../models/useQueryFinancialAccountBalanceSummary'

export const useGetFinancialAccountBalanceSummaryPresenter = ({
  financialAccountId,
  enabled = true,
  scaToken,
  showErrorToast = true,
}: {
  financialAccountId: number | undefined
  enabled?: boolean
  scaToken?: string
  showErrorToast?: boolean
}) => {
  const intl = useProcurifyIntl()

  const { balanceSummary, isFetching } = useQueryFinancialAccountBalanceSummary(
    {
      financialAccountId,
      enabled,
      scaToken,
      onError: () => {
        if (showErrorToast) {
          toast.error({
            title: intl.formatMessage(
              messages.fetchingBalanceSummaryToastError
            ),
          })
        }
      },
    }
  )

  return {
    data: {
      balanceSummary,
    },
    states: {
      isFetching,
    },
  }
}
